import * as actions from '../actions/'
import App from '../App'
import { Props } from '../App'
import { AlertLevel, Model } from '../types/types'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { appPermissions } from '../roles-permissions'
import { userCountsAsLoggedIn } from '../utils'
import {actionCreators} from "../actions/";

type ContainerStateProps = Pick<
  Props,
  | 'alerts'
  | 'alertLevel'
  | 'automaticRedButtonEnabled'
  | 'clients'
  | 'currentPage'
  | 'dataLastUpdated'
  | 'exchangeFreshnessText'
  | 'freshnessText'
  | 'hasPermission'
  | 'hubs'
  | 'initialised'
  | 'localTime'
  | 'metricLevels'
  | 'name'
  | 'selectedClientCode'
  | 'totalMessagesCount'
  | 'dailyTotalNewOrdersValue'
  | 'dailyExecutedOrdersValue'
  | 'user'
>

type ContainerDispatchProps = Pick<
  Props,
  | 'onAlertBadgeClick'
  | 'setClientSettings'
  >

export function mapStateToProps({
  alerts,
  alertLevel,
  automaticRedButtonEnabled,
  currentPage,
  hubs,
  initialised,
  dataLastUpdated,
  languageName,
  lastRJEMessageTimestamp,
  localTime,
  metricLevels,
  clients,
  selectedClientCode,
  totalMessagesCount,
  dailyTotalNewOrdersValue,
  dailyExecutedOrdersValue,
  user,
}: Model): ContainerStateProps {
  const freshnessSeconds = dataLastUpdated
    ? Math.max(0, (localTime.getTime() - dataLastUpdated.getTime()) / 1000)
    : undefined

  const freshnessText = !userCountsAsLoggedIn(user)
    ? 'Not logged in'
    : freshnessSeconds !== undefined
    ? `Last updated ${friendlySeconds(freshnessSeconds)}s ago`
    : `Hub: ${hubs.clientData.state.toLocaleLowerCase()}`

  const exchangeFreshnessSeconds = lastRJEMessageTimestamp
    ? Math.max(
        0,
        (localTime.getTime() - lastRJEMessageTimestamp.getTime()) / 1000,
      )
    : undefined

  const exchangeFreshnessText =
    exchangeFreshnessSeconds !== undefined
      ? `Last exchange message dated ${friendlySeconds(
          exchangeFreshnessSeconds,
        )}s ago`
      : `Waiting for first data...`

  return {
    alertLevel,
    alerts,
    automaticRedButtonEnabled,
    clients,
    currentPage,
    dataLastUpdated,
    exchangeFreshnessText,
    freshnessText,
    hasPermission: appPermissions,
    hubs,
    initialised,
    localTime,
    metricLevels,
    name: languageName,
    selectedClientCode,
    totalMessagesCount,
    dailyTotalNewOrdersValue,
    dailyExecutedOrdersValue,
    user,
  }
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.RootAction>,
): ContainerDispatchProps {
  return {
    onAlertBadgeClick: (
      level: AlertLevel,
    ): ReturnType<Props['onAlertBadgeClick']> => (): void => {
      dispatch(actions.clearAlertsFilters())
      dispatch(actions.toggleShowOnlyActiveAlerts(true))
      if (level !== 'Baseline') {
        dispatch(actions.setAlertsSeverityFilter(['level', level]))
      }
    },
    setClientSettings: (clientSettings) => dispatch(actionCreators.setClientSettings(clientSettings))
  }
}

function mergeProps(
  stateProps: ContainerStateProps,
  dispatchProps: ContainerDispatchProps,
  ownProps: {}, // Is this the correct type???
): ContainerStateProps & ContainerDispatchProps {
  return { ...ownProps, ...stateProps, ...dispatchProps }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(App)

export function friendlySeconds(s: number): string {
  if (s < 1) {
    return '<1'
  }
  return `${s.toFixed(0)}`
}
